import React, { Component } from 'react';
import { Input, Modal, Button, Card, Tabs, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker, Spin } from 'antd';
import { compose } from 'recompose';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './profile.css';
import Skeleton from 'react-loading-skeleton';

const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const Panel = Collapse.Panel;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;

const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
};

class AdditionalInfoForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ethinicId: ''
        }
    }
    ethnicities = () => {
        if (this.props.ethnicities) {
            let ethnicitiesArray = this.props.ethnicities
            return ethnicitiesArray.map((k, index) => {
                return (
                    <option key={index} value={k.name}>{k.name}</option>
                )
            })
        }
    }

    componentDidMount = () => {
        this.props.actions.getEthnicities()
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.actions.UpdateAdditionalInfo(this.state.ethinicId, values)
            }
        })
    }

    cancelActions = () => {
        let loggedinUser = JSON.parse(localStorage.getItem('user'))
        let personGUID = loggedinUser.personGuid;
        this.props.actions.getProfileInfo(personGUID)
    }

    renderEditValues = (profileinfo) => {
        const Option = Select.Option;
        const FormItem = Form.Item;
        const dateFormat = 'YYYY/MM/DD';
        const { firstName } = this.state;
        const { getFieldDecorator, getFieldValue } = this.props.form;
        let hobby, ethinic, maritalstatus, privacysettings = ''
        if (profileinfo.extendedProfile) {
            profileinfo.extendedProfile.filter((data) => {
                if (data.attributeId == 1) {
                    ethinic = data.attributeVal
                    if (this.state.ethinicId == '') {
                        this.setState({
                            ethinicId: data.extendedProfileId
                        })
                    }
                }
                if (data.attributeId == 5) {
                    maritalstatus = data.attributeVal
                }
                if (data.attributeId == 16) {
                    hobby = data.attributeVal
                }
                if (data.attributeId == 17) {
                    privacysettings = data.attributeVal
                }
            })
        }
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };
        return (<div>
            <Form onSubmit={this.handleSubmit} className="additional-info-form">
                <Row type='flex' justify='start'>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <FormItem
                            label="Select any primary communication"
                        >
                            {getFieldDecorator('ethnic', {
                                initialValue: ethinic ? ethinic : "",
                                rules: [{ required: true, message: 'Enter Ethnic Background!' }],
                            })(
                                <Radio.Group onChange={this.onChange} value={this.state.value}>
                                    <Radio style={radioStyle} value={1}>Email</Radio>
                                    <Radio style={radioStyle} value={2}>Address</Radio>
                                    <Radio style={radioStyle} value={3}>Newsletter</Radio>
                                </Radio.Group>
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row type='flex' className='btn-action' justify='space-around'>
                    <Col xs={23} sm={23} md={18} lg={18} xl={18}>
                        <Row type='flex' justify='space-around'>
                            <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                                <FormItem>
                                    <Button onClick={() => this.cancelActions()} className="myprofile-cancel-btn">CANCEL</Button>
                                </FormItem>
                            </Col>
                            <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                                <FormItem>
                                    <Button className="save-change-btn" style={{margin: '0px', height: '56px'}} htmlType="submit" type="primary">SAVE CHANGES</Button>
                                </FormItem>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </div >)
    }

    renderEditView = () => {
        if (this.props.updating) {
            return (<Spin indicator={LoadingIcon} className="loading-state" style={{ 'min-height': 150 }} tip="Updating Information..." />)
        }
        else if (this.props.loading) {
            return (<Spin indicator={LoadingIcon} className="loading-state" style={{ 'min-height': 150 }} tip="Loading Information..." />)
        }
        else if (this.props.profileinfo) {
            return this.renderEditValues(this.props.profileinfo)
        }
        else {
            return (<Spin indicator={LoadingIcon} className="loading-state" style={{ 'min-height': 150 }} tip="Loading Information..." />)
        }
    }


    render() {
        return (
            <div>
                <Card
                    className="card-margin centered"
                    title="COMMUNICATION PREFERENCES"
                >
                    {this.renderEditView()}

                </Card>

            </div>
        )
    }
}


function mapStateToProps(state) {
    return {
        profileinfo: state.profilereducer.profileinfo,
        ethnicities_loading: state.ethnicitiesreducer.loading,
        ethnicities: state.ethnicitiesreducer.ethnicities,
        updating: state.additionalinforamtionreducer.loading,
        loading: state.profilereducer.loading
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}
const AdditionalInfo = Form.create()(AdditionalInfoForm);
export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(AdditionalInfo);



// WEBPACK FOOTER //
// ./src/components/MyProfile/AdditionalInfo.js